// UI texts for the current language. The server renders the "Js.*" translation keys (editable in the
// CMS panel) into window.AcrText before the bundle runs; keys are used without the "Js." prefix.

export function currentLang() {
    return (document.documentElement.lang || "tr").slice(0, 2).toLowerCase();
}

/** t("Copy.Done") / t("BankAccounts.IbansCopied", count) — {0}, {1} … are replaced by the arguments. */
export function t(key, ...args) {
    const text = window.AcrText?.[key];
    if (typeof text !== "string") return `[Js.${key}]`;
    return text.replace(/\{(\d+)\}/g, (match, index) => (args[index] ?? match));
}
